import { UnknownAction, Dispatch, PayloadAction, createSlice } from '@reduxjs/toolkit'
import { TranslatorKeys } from '../../Translator';

export interface OperationStatus {
    warning: boolean;
    message: TranslatorKeys;
    errors: string[]
}
let timer = 0;
export const setOperationStatusWithDuration = (status: OperationStatus | null, seconds: number, dispatch: Dispatch<UnknownAction>) => {
    if (timer) {
        window.clearTimeout(timer);
        timer = 0;
    }
    timer = window.setTimeout(() => dispatch(operationStatusSet(null)), 1000 * seconds);
    dispatch(operationStatusSet(status));
}

const operationSlice = createSlice({
    name: 'SLICE_operation',
    initialState: null as OperationStatus | null,
    reducers: {
        operationStatusSet(state, action: PayloadAction<OperationStatus | null>) {
            state = action.payload;
        }
    },
})

export const { operationStatusSet } = operationSlice.actions

export default operationSlice.reducer
